<template>
  <component
    :is="item.component"
    class="c1"
    :id="item.ref"
    :class="item.css"
    :to="item.to"
    :src="item.src"
    :title="item.title"
    :text="item.text"
    :button-text="item.buttonText"
    :bg-color="item.bgColor"
    :link-mode="item.linkMode"
    :card-css="item.cardCss"
    :title-class="item.titleClass"
    :text-class="item.textClass"
    :button-class="item.buttonClass"
    :autoplay="item.autoplay"
    :muted="item.muted"
    :repeat="item.repeat"
    :controls="item.controls"
    :fit="item.fit"
    :items-per-row="item.itemsPerRow"
    :category-template="item.categoryTemplate"
    :category-product-template="item.categoryProductTemplate"
    :product-template="item.productTemplate"
    :sliders="item.slides"
    :mode="item.sliderMode"
    :padding="Number(item.sliderPadding || 0)"
    :carousel-id="`${item.ref}-carousel`"
    :account="item.account"
    :columns="item.columns"
    :quantity="item.quantity"
    :show-description="item.showDescription"
    :show-category-menu="item.showCategoryMenu"
    :show-search="item.showSearch"
    :category-name-align="item.categoryNameAlign"
    :category-icon-mode="item.categoryIconMode"
    :show-category-description="item.showCategoryDescription"
    :store-eyebrow="item.storeEyebrow"
    :store-title="item.storeTitle"
    :store-subtitle="item.storeSubtitle"
    :minimum-rating="item.minimumRating"
    :show-review-count="item.showReviewCount"
    :show-average-rating="item.showAverageRating"
    :max-comments="item.maxComments"
    :most-products-limit="item.mostProductsLimit"
    :offer-products-limit="item.offerProductsLimit"
    :hours-mode="item.hoursMode"
    :eyebrow="item.hoursEyebrow"
    :today-label="item.hoursTodayLabel"
    :week-label="item.hoursWeekLabel"
    :pause-label="item.hoursPauseLabel"
    :closed-label="item.hoursClosedLabel"
    :no-today-hours-text="item.hoursNoTodayHoursText"
    :temporary-closed-text="item.hoursTemporaryClosedText"
    :opens-later-text="item.hoursOpensLaterText"
    :closed-today-text="item.hoursClosedTodayText"
    :on-break-text="item.hoursOnBreakText"
    :open-status-text="item.hoursOpenStatusText"
    :empty-title="item.hoursEmptyTitle"
    :empty-text="item.hoursEmptyText"
    :accent-color="item.hoursAccentColor"
    :today-color="item.hoursTodayColor"
    :today-text-color="item.hoursTodayTextColor"
    :background-color="item.hoursBackgroundColor"
    :heading-color="item.hoursHeadingColor"
    :review-eyebrow="item.reviewEyebrow"
    :review-title="item.reviewTitle"
    :review-subtitle="item.reviewSubtitle"
    :review-empty-comment-text="item.reviewEmptyCommentText"
    :review-verified-label="item.reviewVerifiedLabel"
    :review-name-mode="item.reviewNameMode"
    :params="item.params"
  >
    {{ item.content }}
    <component-builder
      :item="subitem"
      v-for="subitem in item.items"
      :key="subitem._id"
    >
      {{ subitem.content }}}
    </component-builder>
  </component>
</template>

<script>
// import singleProduct from "./singleProduct";
// import row from "./row";
// import btnlink from "./btnlink";
// import customImage from "./image";
// import productsMenu from "../pages/Home";
// import cart from "../pages/Cart.vue";
// import delivery from "../pages/Zones.vue";
// import lastProducts from "./lastProducts";
// import embedVideo from "./embedVideo";
// import productList from '../pages/Products.vue'
// import instagramFeed from './instagramFeed.vue'
// import mostProducts from './mostProducts.vue'
// import redirect from './redirect.vue'
// import category from './category.vue'
// import onlycategory from './onlyCategory.vue'
// import feedback from './feedback.vue'

const singleProduct = () => import(/* webpackChunkName: "singleproduct" */"./singleProduct.vue");
const row = () => import(/* webpackChunkName: "row" */"./row.vue");
const btnlink = () => import(/* webpackChunkName: "btnlink" */"./btnlink.vue");
const customImage = () => import(/* webpackChunkName: "image" */"./image.vue");
const promoCard = () => import(/* webpackChunkName: "promoCard" */"./promoCard.vue");
const productsMenu = () => import(/* webpackChunkName: "productsMenu" */"../pages/Home.vue");
const cart = () => import(/* webpackChunkName: "cart" */"../pages/Cart.vue");
const delivery = () => import(/* webpackChunkName: "delivery" */"../pages/Zones.vue");
const lastProducts = () => import(/* webpackChunkName: "lastProducts" */"./lastProducts.vue");
const embedVideo = () => import(/* webpackChunkName: "embedVideo" */"./embedVideo.vue");
const slider = () => import(/* webpackChunkName: "slider" */"./Slider.vue");
const productList = () => import(/* webpackChunkName: "productList" */'../pages/Products.vue');
const instagramFeed = () => import(/* webpackChunkName: "instagramFeed" */'./instagramFeed.vue');
const mostProducts = () => import(/* webpackChunkName: "mostProducts" */'./mostProducts.vue');
const offerProducts = () => import(/* webpackChunkName: "offerProducts" */'./offerProducts.vue');
const recommendedProducts = () => import(/* webpackChunkName: "recommendedProducts" */'./recommendedProducts.vue');
const redirect = () => import(/* webpackChunkName: "redirect" */'./redirect.vue');
const category = () => import(/* webpackChunkName: "category" */'./category.vue');
const onlycategory = () => import(/* webpackChunkName: "onlycategory" */'./onlyCategory.vue');
const feedback = () => import(/* webpackChunkName: "feedback" */'./feedback.vue');
const openingHours = () => import(/* webpackChunkName: "openingHours" */'./openingHours.vue');


export default {
  components: {
    feedback,
    openingHours,
    singleProduct,
    row,
    btnlink,
    customImage,
    promoCard,
    productsMenu,
    cart,
    delivery,
    lastProducts,
    embedVideo,
    slider,
    productList,
    instagramFeed,
    mostProducts,
    offerProducts,
    recommendedProducts,
    redirect,
    category,
    onlycategory,
    column6: {
      template: '<div class="col-12 col-md-6"><slot></slot></div>',
    },
    column4: {
      template: '<div class="col-12 col-xs-4 col-md-4"><slot></slot></div>',
    },
    column3: {
      template: '<div class="col-12 col-md-3"><slot></slot></div>',
    },
    column: {
      template: '<div class="col-12 col-md-12"><slot></slot></div>',
    },
  },
  name: "ComponentBuilder",
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  methods: {

  }
};
</script>
